/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const Cast = require('../../util/cast');
const util = require('../../engine/block-utility');
const StringUtil = require('../../util/string-util');
const { color } = require('minilog/lib/web/console');

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
const blockIconURI = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iX+ODrOOCpOODpOODvF8xIiBkYXRhLW5hbWU9IuODrOOCpOODpOODvCAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4xMTFtbSIgaGVpZ2h0PSIxNC4xMTFtbSIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xLCAuY2xzLTIsIC5jbHMtMywgLmNscy00LCAuY2xzLTUsIC5jbHMtNiwgLmNscy03LCAuY2xzLTgsIC5jbHMtOSwgLmNscy0xMCB7CiAgICAgICAgc3Ryb2tlLWxpbmVjYXA6IHJvdW5kOwogICAgICAgIHN0cm9rZS1saW5lam9pbjogcm91bmQ7CiAgICAgIH0KCiAgICAgIC5jbHMtMSwgLmNscy0yLCAuY2xzLTMsIC5jbHMtNCwgLmNscy01LCAuY2xzLTYsIC5jbHMtOCwgLmNscy05LCAuY2xzLTEwIHsKICAgICAgICBzdHJva2U6ICMwNDAwMDA7CiAgICAgIH0KCiAgICAgIC5jbHMtMSwgLmNscy0yLCAuY2xzLTMsIC5jbHMtNiwgLmNscy04LCAuY2xzLTEwIHsKICAgICAgICBzdHJva2Utd2lkdGg6IC4wNjFweDsKICAgICAgfQoKICAgICAgLmNscy0xLCAuY2xzLTUgewogICAgICAgIGZpbGw6ICM5ZTlmOWY7CiAgICAgIH0KCiAgICAgIC5jbHMtMTEgewogICAgICAgIHN0cm9rZS13aWR0aDogMHB4OwogICAgICB9CgogICAgICAuY2xzLTExLCAuY2xzLTcgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5jbHMtMiB7CiAgICAgICAgZmlsbDogI2Y5ZjZjMjsKICAgICAgfQoKICAgICAgLmNscy0zIHsKICAgICAgICBmaWxsOiAjZGRhZjM4OwogICAgICB9CgogICAgICAuY2xzLTQsIC5jbHMtNSwgLmNscy03LCAuY2xzLTkgewogICAgICAgIHN0cm9rZS13aWR0aDogLjIwMnB4OwogICAgICB9CgogICAgICAuY2xzLTQsIC5jbHMtOCB7CiAgICAgICAgZmlsbDogIzU4NTc1NzsKICAgICAgfQoKICAgICAgLmNscy02IHsKICAgICAgICBmaWxsOiAjZWVlZWVmOwogICAgICB9CgogICAgICAuY2xzLTcgewogICAgICAgIHN0cm9rZTogI2RkYWYzODsKICAgICAgfQoKICAgICAgLmNscy05IHsKICAgICAgICBmaWxsOiAjMDQwMDAwOwogICAgICB9CgogICAgICAuY2xzLTEwIHsKICAgICAgICBmaWxsOiAjZWQ2ZTQ3OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8Zz4KICAgIDxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTI5Ljc0MywzLjEzNGwtLjA0My0uMTktLjA2OS0uMTgxLS4xMDMtLjE2NC0uMTIxLS4xNDYtLjE0Ni0uMTIxLS4xNjQtLjEwMy0uMTgxLS4wNjktLjE4MS0uMDQzLS4xOTgtLjAxN0gxMS40NTVsLS4xOS4wMTctLjE5LjA0My0uMTcyLjA2OS0uMTY0LjEwMy0uMTQ2LjEyMS0uMTIxLjE0Ni0uMTAzLjE2NC0uMDc4LjE4MS0uMDQzLjE5LS4wMDkuMTl2MzMuMzU0bC4wMDkuMTkuMDQzLjE5LjA3OC4xNzIuMTAzLjE2NC4xMjEuMTQ2LjE0Ni4xMjkuMTY0LjA5NS4xNzIuMDc4LjE5LjA0My4xOS4wMTdoMTcuMDgybC4xOTgtLjAxNy4xODEtLjA0My4xODEtLjA3OC4xNjQtLjA5NS4xNDYtLjEyOS4xMjEtLjE0Ni4xMDMtLjE2NC4wNjktLjE3Mi4wNDMtLjE5LjAxNy0uMTlWMy4zMjNsLS4wMTctLjE5Wk0xMS44NjgsMzYuOTg3Yy0uMzk1LDAtLjcxNS0uMzItLjcxNS0uNzE1cy4zMi0uNzE1LjcxNS0uNzE1LjcxNS4zMi43MTUuNzE1LS4zMi43MTUtLjcxNS43MTVaTTExLjg2OCw0LjQ0M2MtLjM5NSwwLS43MTUtLjMyLS43MTUtLjcxNXMuMzItLjcxNS43MTUtLjcxNS43MTUuMzIuNzE1LjcxNS0uMzIuNzE1LS43MTUuNzE1Wk0xNC4yMTEsMjAuOTNjLS4yNTcsMC0uNDY1LS4yMDgtLjQ2NS0uNDY1cy4yMDgtLjQ2NS40NjUtLjQ2NS40NjUuMjA4LjQ2NS40NjUtLjIwOC40NjUtLjQ2NS40NjVaTTI2LjQwOSwyMC45M2MtLjI1NywwLS40NjUtLjIwOC0uNDY1LS40NjVzLjIwOC0uNDY1LjQ2NS0uNDY1LjQ2NS4yMDguNDY1LjQ2NS0uMjA4LjQ2NS0uNDY1LjQ2NVpNMjguMTQsMzYuOTg3Yy0uMzk1LDAtLjcxNS0uMzItLjcxNS0uNzE1cy4zMi0uNzE1LjcxNS0uNzE1LjcxNS4zMi43MTUuNzE1LS4zMi43MTUtLjcxNS43MTVaTTI4LjE0LDQuNDQzYy0uMzk1LDAtLjcxNS0uMzItLjcxNS0uNzE1cy4zMi0uNzE1LjcxNS0uNzE1LjcxNS4zMi43MTUuNzE1LS4zMi43MTUtLjcxNS43MTVaIi8+CiAgICA8Zz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIxMC42MzkiIHk9IjkuMDc0IiB3aWR0aD0iMTguNzIyIiBoZWlnaHQ9IjIzLjA3NSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjEwLjYzOSIgeT0iOS4wNzQiIHdpZHRoPSIxOC43MjIiIGhlaWdodD0iLjg3MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjEwLjYzOSIgeT0iMzEuMjc4IiB3aWR0aD0iMTguNzIyIiBoZWlnaHQ9Ii44NzEiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIxMC42MzkiIHk9IjkuOTQ1IiB3aWR0aD0iLjYwNyIgaGVpZ2h0PSIyMS4zMzMiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIyOC43NTQiIHk9IjkuOTQ1IiB3aWR0aD0iLjYwNyIgaGVpZ2h0PSIyMS4zMzMiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIyMi43MTYiIHk9IjkuOTQ1IiB3aWR0aD0iLjYwNyIgaGVpZ2h0PSIyMS4zMzMiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIxNi42NzciIHk9IjkuOTQ1IiB3aWR0aD0iLjYwNyIgaGVpZ2h0PSIyMS4zMzMiLz4KICAgICAgPGc+CiAgICAgICAgPGc+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxNi4yMzkiIHkxPSIzMS4wNjMiIHgyPSIxMS42ODUiIHkyPSIzMS4wNjMiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE1LjA1IiB5MT0iMjguODg2IiB4Mj0iMTIuODc0IiB5Mj0iMjguODg2Ii8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxNS40OCIgeTE9IjI5LjYxMiIgeDI9IjEyLjQ0NCIgeTI9IjI5LjYxMiIvPgogICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy03IiB4MT0iMTUuODU5IiB5MT0iMzAuMzM3IiB4Mj0iMTIuMDY0IiB5Mj0iMzAuMzM3Ii8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxNS44NTkiIHkxPSIzMC4zMzciIHgyPSIxMS42ODUiIHkyPSIzMS4wNjMiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE1LjQ4IiB5MT0iMjkuNjEyIiB4Mj0iMTIuMDY0IiB5Mj0iMzAuMzM3Ii8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxNS4wNSIgeTE9IjI4Ljg4NiIgeDI9IjEyLjQ0NCIgeTI9IjI5LjYxMiIvPgogICAgICAgIDwvZz4KICAgICAgICA8Zz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjI4LjMxNSIgeTE9IjMxLjA2MyIgeDI9IjIzLjc2MSIgeTI9IjMxLjA2MyIvPgogICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy03IiB4MT0iMjcuMTI2IiB5MT0iMjguODg2IiB4Mj0iMjQuOTUiIHkyPSIyOC44ODYiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjI3LjU1NiIgeTE9IjI5LjYxMiIgeDI9IjI0LjUyIiB5Mj0iMjkuNjEyIi8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIyNy45MzYiIHkxPSIzMC4zMzciIHgyPSIyNC4xNDEiIHkyPSIzMC4zMzciLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjI3LjkzNiIgeTE9IjMwLjMzNyIgeDI9IjIzLjc2MSIgeTI9IjMxLjA2MyIvPgogICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy03IiB4MT0iMjcuNTU2IiB5MT0iMjkuNjEyIiB4Mj0iMjQuMTQxIiB5Mj0iMzAuMzM3Ii8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIyNy4xMjYiIHkxPSIyOC44ODYiIHgyPSIyNC41MiIgeTI9IjI5LjYxMiIvPgogICAgICAgIDwvZz4KICAgICAgICA8Zz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE3LjcyMyIgeTE9IjEwLjE2IiB4Mj0iMjIuMjc3IiB5Mj0iMTAuMTYiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE4LjkxMiIgeTE9IjEyLjMzNyIgeDI9IjIxLjA4OCIgeTI9IjEyLjMzNyIvPgogICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy03IiB4MT0iMTguNDgyIiB5MT0iMTEuNjEyIiB4Mj0iMjEuNTE4IiB5Mj0iMTEuNjEyIi8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxOC4xMDIiIHkxPSIxMC44ODYiIHgyPSIyMS44OTgiIHkyPSIxMC44ODYiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE4LjEwMiIgeTE9IjEwLjg4NiIgeDI9IjIyLjI3NyIgeTI9IjEwLjE2Ii8+CiAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTciIHgxPSIxOC40ODIiIHkxPSIxMS42MTIiIHgyPSIyMS44OTgiIHkyPSIxMC44ODYiLz4KICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjE4LjkxMiIgeTE9IjEyLjMzNyIgeDI9IjIxLjUxOCIgeTI9IjExLjYxMiIvPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjIuNTQyIiB5PSIzMy41MjUiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjIuODkzIiB5PSIzMy44NzYiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjIzLjU2NyIgeT0iMzMuNTI1IiB3aWR0aD0iMS4wMjUiIGhlaWdodD0iMS4wMjUiIHJ4PSIuMjAyIiByeT0iLjIwMiIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjIzLjkxOCIgeT0iMzMuODc2IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyNC41OTEiIHk9IjMzLjUyNSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyNC45NDIiIHk9IjMzLjg3NiIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjUuNjE2IiB5PSIzMy41MjUiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjUuOTY3IiB5PSIzMy44NzYiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTEwIiB4PSIyMi41NDIiIHk9IjM0LjU0OSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyMi44OTMiIHk9IjM0LjkiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTEwIiB4PSIyMy41NjciIHk9IjM0LjU0OSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyMy45MTgiIHk9IjM0LjkiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTEwIiB4PSIyNC41OTEiIHk9IjM0LjU0OSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyNC45NDIiIHk9IjM0LjkiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTEwIiB4PSIyNS42MTYiIHk9IjM0LjU0OSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyNS45NjciIHk9IjM0LjkiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjIyLjU0MiIgeT0iMzUuNTc0IiB3aWR0aD0iMS4wMjUiIGhlaWdodD0iMS4wMjUiIHJ4PSIuMjAyIiByeT0iLjIwMiIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjIyLjg5MyIgeT0iMzUuOTI1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy04IiB4PSIyMy41NjciIHk9IjM1LjU3NCIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyMy45MTgiIHk9IjM1LjkyNSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtOCIgeD0iMjQuNTkxIiB5PSIzNS41NzQiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjQuOTQyIiB5PSIzNS45MjUiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjI1LjYxNiIgeT0iMzUuNTc0IiB3aWR0aD0iMS4wMjUiIGhlaWdodD0iMS4wMjUiIHJ4PSIuMjAyIiByeT0iLjIwMiIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjI1Ljk2NyIgeT0iMzUuOTI1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiLz4KICAgIDwvZz4KICAgIDxnPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjE2LjU4IiB5PSIzNC40NDYiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Mi4wNTEgMTcuODY3KSByb3RhdGUoOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTYuOTMxIiB5PSIzNC43OTciIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTIuMDUxIDE3Ljg2Nykgcm90YXRlKDkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjE2LjU4IiB5PSIzNS40NzEiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1My4wNzUgMTguODkxKSByb3RhdGUoOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTYuOTMxIiB5PSIzNS44MjIiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMuMDc1IDE4Ljg5MSkgcm90YXRlKDkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjE1LjU1NSIgeT0iMzQuNDQ2IiB3aWR0aD0iMS4wMjUiIGhlaWdodD0iMS4wMjUiIHJ4PSIuMjAyIiByeT0iLjIwMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTEuMDI2IDE4Ljg5MSkgcm90YXRlKDkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjE1LjkwNiIgeT0iMzQuNzk3IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUxLjAyNiAxOC44OTEpIHJvdGF0ZSg5MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy04IiB4PSIxNS41NTUiIHk9IjM1LjQ3MSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUyLjA1MSAxOS45MTYpIHJvdGF0ZSg5MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxNS45MDYiIHk9IjM1LjgyMiIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Mi4wNTEgMTkuOTE2KSByb3RhdGUoOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtOCIgeD0iMTQuNTMiIHk9IjM0LjQ0NiIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwLjAwMSAxOS45MTYpIHJvdGF0ZSg5MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxNC44ODEiIHk9IjM0Ljc5NyIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MC4wMDEgMTkuOTE2KSByb3RhdGUoOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtOCIgeD0iMTQuNTMiIHk9IjM1LjQ3MSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUxLjAyNiAyMC45NDEpIHJvdGF0ZSg5MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxNC44ODEiIHk9IjM1LjgyMiIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MS4wMjYgMjAuOTQxKSByb3RhdGUoOTApIi8+CiAgICAgIDxnPgogICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtOCIgeD0iMTMuNTA2IiB5PSIzNC40NDYiIHdpZHRoPSIxLjAyNSIgaGVpZ2h0PSIxLjAyNSIgcng9Ii4yMDIiIHJ5PSIuMjAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OC45NzcgMjAuOTQxKSByb3RhdGUoOTApIi8+CiAgICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxMy44NTciIHk9IjM0Ljc5NyIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OC45NzcgMjAuOTQxKSByb3RhdGUoOTApIi8+CiAgICAgICAgPHJlY3QgY2xhc3M9ImNscy04IiB4PSIxMy41MDYiIHk9IjM1LjQ3MSIgd2lkdGg9IjEuMDI1IiBoZWlnaHQ9IjEuMDI1IiByeD0iLjIwMiIgcnk9Ii4yMDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwLjAwMSAyMS45NjUpIHJvdGF0ZSg5MCkiLz4KICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEzLjg1NyIgeT0iMzUuODIyIiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwLjAwMSAyMS45NjUpIHJvdGF0ZSg5MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjgzMSwzNS43NzNjMCwuMDMzLS4wMjcuMDYxLS4wNjEuMDYxcy0uMDYxLS4wMjctLjA2MS0uMDYxaC0uMTAxdi42NDVoLjEwMWMwLS4wMzMuMDI3LS4wNjEuMDYxLS4wNjFzLjA2MS4wMjcuMDYxLjA2MWguMTAxdi0uNjQ1aC0uMTAxWiIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjIwLjYxIiB5PSIzNS44NTMiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii40ODQiLz4KICAgIDwvZz4KICAgIDxnPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOS4yMjksMzUuNzczYzAsLjAzMy0uMDI3LjA2MS0uMDYxLjA2MXMtLjA2MS0uMDI3LS4wNjEtLjA2MWgtLjEwMXYuNjQ1aC4xMDFjMC0uMDMzLjAyNy0uMDYxLjA2MS0uMDYxcy4wNjEuMDI3LjA2MS4wNjFoLjEwMXYtLjY0NWgtLjEwMVoiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0yIiB4PSIxOS4wMDciIHk9IjM1Ljg1MyIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjQ4NCIvPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjYyNSwyLjgxMWMwLC4wMzMtLjAyNy4wNjEtLjA2MS4wNjFzLS4wNjEtLjAyNy0uMDYxLS4wNjFoLS4xMDF2LjY0NWguMTAxYzAtLjAzMy4wMjctLjA2MS4wNjEtLjA2MXMuMDYxLjAyNy4wNjEuMDYxaC4xMDF2LS42NDVoLS4xMDFaIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMjAuNDAzIiB5PSIyLjg5MSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjQ4NCIvPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjAyMywyLjgxMWMwLC4wMzMtLjAyNy4wNjEtLjA2MS4wNjFzLS4wNjEtLjAyNy0uMDYxLS4wNjFoLS4xMDF2LjY0NWguMTAxYzAtLjAzMy4wMjctLjA2MS4wNjEtLjA2MXMuMDYxLjAyNy4wNjEuMDYxaC4xMDF2LS42NDVoLS4xMDFaIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTguODAxIiB5PSIyLjg5MSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjQ4NCIvPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxnIGlkPSJMV1BPTFlMSU5FIj4KICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTkiIHg9IjE2LjAxNiIgeT0iLjk4MiIgd2lkdGg9Ii44MDciIGhlaWdodD0iMS4xNyIvPgogICAgICA8L2c+CiAgICAgIDxnIGlkPSJMV1BPTFlMSU5FLTIiIGRhdGEtbmFtZT0iTFdQT0xZTElORSI+CiAgICAgICAgPHJlY3QgY2xhc3M9ImNscy01IiB4PSIxNC4yNjEiIHk9IjIuMTUxIiB3aWR0aD0iMy41MSIgaGVpZ2h0PSIxLjc3NSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgICA8cmVjdCBjbGFzcz0iY2xzLTUiIHg9IjIyLjA1IiB5PSIyLjEyNiIgd2lkdGg9IjMuNjM1IiBoZWlnaHQ9IjIuNTc4Ii8+CiAgICA8Zz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy02IiB4PSIyMy44ODciIHk9IjYuMjk2IiB3aWR0aD0iMy45OTMiIGhlaWdodD0iMS44MTYiLz4KICAgICAgPHBvbHlnb24gY2xhc3M9ImNscy02IiBwb2ludHM9IjI0LjA4OSA3LjI0NiAyMy44ODcgNy4yNDYgMjMuODg3IDcuNDQ4IDI0LjA4OSA3LjQ0OCAyNC4wODkgNy45MSAyNC45NzcgNy45MSAyNC45NzcgOC4xMTIgMjYuNzkgOC4xMTIgMjYuNzkgNy45MSAyNy42NzggNy45MSAyNy42NzggNy40NDggMjcuODggNy40NDggMjcuODggNy4yNDYgMjcuNjc4IDcuMjQ2IDI3LjY3OCA2LjQ5NyAyNC4wODkgNi40OTcgMjQuMDg5IDcuMjQ2Ii8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjQuNTIyIiB5PSI3LjE4NSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNy4zMzcgMzIuMDMpIHJvdGF0ZSgtOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjYuOTQiIHk9IjcuMTg1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5Ljc1NSAzNC40NDgpIHJvdGF0ZSgtOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMjUuMzI5IiB5PSI3LjE4NSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOC4xNDMgMzIuODM3KSByb3RhdGUoLTkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjI2LjEzNSIgeT0iNy4xODUiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTguOTQ5IDMzLjY0Mykgcm90YXRlKC05MCkiLz4KICAgIDwvZz4KICAgIDxnPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTYiIHg9IjE4LjAwNCIgeT0iNi4yOTYiIHdpZHRoPSIzLjk5MyIgaGVpZ2h0PSIxLjgxNiIvPgogICAgICA8cG9seWdvbiBjbGFzcz0iY2xzLTYiIHBvaW50cz0iMTguMjA1IDcuMjQ2IDE4LjAwNCA3LjI0NiAxOC4wMDQgNy40NDggMTguMjA1IDcuNDQ4IDE4LjIwNSA3LjkxIDE5LjA5MyA3LjkxIDE5LjA5MyA4LjExMiAyMC45MDcgOC4xMTIgMjAuOTA3IDcuOTEgMjEuNzk1IDcuOTEgMjEuNzk1IDcuNDQ4IDIxLjk5NiA3LjQ0OCAyMS45OTYgNy4yNDYgMjEuNzk1IDcuMjQ2IDIxLjc5NSA2LjQ5NyAxOC4yMDUgNi40OTcgMTguMjA1IDcuMjQ2Ii8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTguNjM4IiB5PSI3LjE4NSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS40NTMgMjYuMTQ3KSByb3RhdGUoLTkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjIxLjA1NyIgeT0iNy4xODUiIHdpZHRoPSIuMzIzIiBoZWlnaHQ9Ii4zMjMiIHJ4PSIuMTYxIiByeT0iLjE2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuODcyIDI4LjU2NSkgcm90YXRlKC05MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxOS40NDUiIHk9IjcuMTg1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjI2IDI2Ljk1Mykgcm90YXRlKC05MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyMC4yNTEiIHk9IjcuMTg1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjA2NiAyNy43NTkpIHJvdGF0ZSgtOTApIi8+CiAgICA8L2c+CiAgICA8Zz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy02IiB4PSIxMi4zMTgiIHk9IjYuMjk2IiB3aWR0aD0iMy45OTMiIGhlaWdodD0iMS44MTYiLz4KICAgICAgPHBvbHlnb24gY2xhc3M9ImNscy02IiBwb2ludHM9IjEyLjUyIDcuMjQ2IDEyLjMxOCA3LjI0NiAxMi4zMTggNy40NDggMTIuNTIgNy40NDggMTIuNTIgNy45MSAxMy40MDggNy45MSAxMy40MDggOC4xMTIgMTUuMjIxIDguMTEyIDE1LjIyMSA3LjkxIDE2LjEwOSA3LjkxIDE2LjEwOSA3LjQ0OCAxNi4zMTEgNy40NDggMTYuMzExIDcuMjQ2IDE2LjEwOSA3LjI0NiAxNi4xMDkgNi40OTcgMTIuNTIgNi40OTcgMTIuNTIgNy4yNDYiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxMi45NTMiIHk9IjcuMTg1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNzY4IDIwLjQ2MSkgcm90YXRlKC05MCkiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxNS4zNzIiIHk9IjcuMTg1IiB3aWR0aD0iLjMyMyIgaGVpZ2h0PSIuMzIzIiByeD0iLjE2MSIgcnk9Ii4xNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMTg2IDIyLjg4KSByb3RhdGUoLTkwKSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEzLjc2IiB5PSI3LjE4NSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU3NSAyMS4yNjgpIHJvdGF0ZSgtOTApIi8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTQuNTY2IiB5PSI3LjE4NSIgd2lkdGg9Ii4zMjMiIGhlaWdodD0iLjMyMyIgcng9Ii4xNjEiIHJ5PSIuMTYxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjM4IDIyLjA3NCkgcm90YXRlKC05MCkiLz4KICAgIDwvZz4KICA8L2c+CiAgPHJlY3QgY2xhc3M9ImNscy0xMSIgeD0iMTAuMjQiIHk9Ii45ODIiIHdpZHRoPSIxOS41MiIgaGVpZ2h0PSIzOC4wMzciLz4KPC9zdmc+'
const menuIconURI = 'data:image/svg+xml;base64,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'

// この拡張機能で有効な多言語表示
const AvailableLocales = ['en', 'ja', 'ja-Hira'];

// 多言語化に使用するjsonです。
const Message = {
    categoryName: {
        'ja': 'メイカーボード アドバンスブロック',
        'ja-Hira': 'メイカーボード アドバンスブロック',
        'en': 'MakerBoard Advance',
    },
    help: {
        'ja': '使い方を表示する',
        'ja-Hira': 'つかいかたをひょうじする',
        'en': 'show usage',
    },
    nowtime: {
        'ja': 'タイマー(ミリ秒)',
        'ja-Hira': 'タイマー(ミリびょう)',
        'en': 'timer (ms)',
    },
    pi: {
        'ja': '円周率',
        'ja-Hira': 'えんしゅうりつ',
        'en': 'pi',
    },
    log: {
        'ja': 'メッセージブロックのメッセージ[ID]に[TEXT]を送信',
        'ja-Hira': 'メッセージブロックのメッセージ[ID]に[TEXT]をおくる',
        'en': 'send [TEXT] to message [ID] of message block',
    },
    serialAvailable: {
        'ja': 'パソコンからメッセージを受信したとき',
        'ja-Hira': 'パソコンからメッセージをじゅしんしたとき',
        'en': 'when receiving a message from PC',
    },
    revMessage: {
        'ja': 'パソコンからのメッセージ',
        'ja-Hira': 'パソコンからのメッセージ',
        'en': 'message from PC',
    },
    toNumber: {
        'ja': 'メッセージ[TEXT]を数字に変換',
        'ja-Hira': 'メッセージ[TEXT]をすうじにへんかん',
        'en': 'convert message [TEXT] to number',
    },
    updateList: {
        'ja': 'メイカーボード内のリスト[LIST]をパソコンからのメッセージで更新',
        'ja-Hira': 'メイカーボードないのリスト[LIST]をパソコンからのメッセージでこうしん',
        'en': 'update list [LIST] in MakerBoard with message from PC',
    },
    servowithtime: {
        'ja': 'サーボモータ[SERVO]を[SECOND]秒で[ANGLE1]度から[ANGLE2]度にする',
        'ja-Hira': 'サーボモータ[SERVO]を[SECOND]びょうで[ANGLE1]どから[ANGLE2]どにする',
        'en': 'set servo [SERVO] from [ANGLE1] deg to [ANGLE2] deg in [SECOND] sec',
    },
    servowithtime_two: {
        'ja': '２つ同時に[SECOND]秒でサーボ[SERVO1]を[ANGLE1]度から[ANGLE2]度 サーボ[SERVO2]を[ANGLE3]度から[ANGLE4]度にする',
        'ja-Hira': '２つどうじに[SECOND]びょうでサーボ[SERVO1]を[ANGLE1]どから[ANGLE2]ど サーボ[SERVO2]を[ANGLE3]どから[ANGLE4]どにする',
        'en': 'simultaneously in [SECOND] sec, set servo [SERVO1] from [ANGLE1] to [ANGLE2] deg and servo [SERVO2] from [ANGLE3] to [ANGLE4] deg',
    },
    servowithtime_three: {
        'ja': '３つ同時に[SECOND]秒でサーボ[SERVO1]を[ANGLE1]度から[ANGLE2]度 サーボ[SERVO2]を[ANGLE3]度から[ANGLE4]度 サーボ[SERVO3]を[ANGLE5]度から[ANGLE6]度にする',
        'ja-Hira': '３つどうじに[SECOND]びょうでサーボ[SERVO1]を[ANGLE1]どから[ANGLE2]ど サーボ[SERVO2]を[ANGLE3]どから[ANGLE4]ど サーボ[SERVO3]を[ANGLE5]どから[ANGLE6]どにする',
        'en': 'simultaneously in [SECOND] sec, set servo [SERVO1] from [ANGLE1] to [ANGLE2] deg, servo [SERVO2] from [ANGLE3] to [ANGLE4] deg, servo [SERVO3] from [ANGLE5] to [ANGLE6] deg',
    },
    servowithtime_four: {
        'ja': '４つ同時に[SECOND]秒でサーボ1を[ANGLE1]度から[ANGLE2]度 サーボ2を[ANGLE3]度から[ANGLE4]度 サーボ3を[ANGLE5]度から[ANGLE6]度 サーボ4を[ANGLE7]度から[ANGLE8]度にする',
        'ja-Hira': '４つどうじに[SECOND]びょうでサーボ1を[ANGLE1]どから[ANGLE2]ど サーボ2を[ANGLE3]どから[ANGLE4]ど サーボ3を[ANGLE5]どから[ANGLE6]ど サーボ4を[ANGLE7]どから[ANGLE8]どにする',
        'en': 'simultaneously in [SECOND] sec, set servo 1 [ANGLE1]-[ANGLE2] deg, servo 2 [ANGLE3]-[ANGLE4] deg, servo 3 [ANGLE5]-[ANGLE6] deg, servo 4 [ANGLE7]-[ANGLE8] deg',
    },
    setRTC_DS1307: {
        'ja': 'RTC ピン2 [YY]年[MM]月[DD]日[H]時[M]分[S]秒にセットする',
        'ja-Hira': 'RTC ピン2 [YY]ねん[MM]がつ[DD]にち[H]じ[M]ふん[S]びょうにセットする',
        'en': 'set RTC pin 2 to [YY]y [MM]m [DD]d [H]h [M]min [S]sec',
    },
    getRTC_DS1307: {
        'ja': 'RTC ピン2 時間を取得する',
        'ja-Hira': 'RTC ピン2 じかんをしゅとくする',
        'en': 'get RTC pin 2 time',
    },
    valRTC_DS1307: {
        'ja': 'RTC ピン2 [VALUE]',
        'ja-Hira': 'RTC ピン2 [VALUE]',
        'en': 'RTC pin 2 [VALUE]',
    },
    rgbledselect: {
        'ja': 'フルカラーLED ピン[PIN]の[NUM]個目のLEDを[OUTPUT]にする',
        'ja-Hira': 'フルカラーLED ピン[PIN]の[NUM]こめのLEDを[OUTPUT]にする',
        'en': 'set full-color LED pin [PIN] LED #[NUM] to [OUTPUT]',
    },
    rgbled: {
        'ja': 'フルカラーLED ピン[PIN]の[NUM]個目のLEDの色をあか:[RED], みどり:[GREEN], あお:[BLUE]にする',
        'ja-Hira': 'フルカラーLED ピン[PIN]の[NUM]こめのLEDのいろをあか:[RED], みどり:[GREEN], あお:[BLUE]にする',
        'en': 'set full-color LED pin [PIN] LED #[NUM] to red:[RED], green:[GREEN], blue:[BLUE]',
    },
    neopixelselect: {
        'ja': '[TYPE] NeoPixel ピン[PIN]の[NUM]個目のLEDを[OUTPUT]にする',
        'ja-Hira': '[TYPE] NeoPixel ピン[PIN]の[NUM]こめのLEDを[OUTPUT]にする',
        'en': '[TYPE] NeoPixel pin [PIN] LED #[NUM] to [OUTPUT]',
    },
    neopixel: {
        'ja': '[TYPE] NeoPixel ピン[PIN]の[NUM]個目のLEDの色をあか:[RED], みどり:[GREEN], あお:[BLUE]にする',
        'ja-Hira': '[TYPE] NeoPixel ピン[PIN]の[NUM]こめのLEDのいろをあか:[RED], みどり:[GREEN], あお:[BLUE]にする',
        'en': '[TYPE] NeoPixel pin [PIN] LED #[NUM] to red:[RED], green:[GREEN], blue:[BLUE]',
    },
    neopixelclear: {
        'ja': '[TYPE] NeoPixel ピン[PIN]のLEDをぜんぶOFFにする',
        'ja-Hira': '[TYPE] NeoPixel ピン[PIN]のLEDをぜんぶOFFにする',
        'en': 'turn off all [TYPE] NeoPixel LEDs on pin [PIN]',
    },
    sevensegnum: {
        'ja': '４桁ディスプレイ ピン[PIN]を数字[NUM]を表示',
        'ja-Hira': '４けたディスプレイ ピン[PIN]をすうじ[NUM]をひょうじ',
        'en': 'show number [NUM] on 4-digit display pin [PIN]',
    },
    sevensegstr: {
        'ja': '４桁ディスプレイ ピン[PIN] に文字[TEXT]を表示',
        'ja-Hira': '４けたディスプレイ ピン[PIN] にもじ[TEXT]をひょうじ',
        'en': 'show text [TEXT] on 4-digit display pin [PIN]',
    },
    sevensegclear: {
        'ja': '４桁ディスプレイ ピン[PIN]の表示を消す',
        'ja-Hira': '４けたディスプレイ ピン[PIN]のひょうじをけす',
        'en': 'clear 4-digit display pin [PIN]',
    },
    lcdtext: {
        'ja': 'LCDディスプレイ ピン2 1行目に[TEXT]，2行目に[TEXT2]を表示',
        'ja-Hira': 'LCDディスプレイ ピン2 1ぎょうめに[TEXT]，2ぎょうめに[TEXT2]をひょうじ',
        'en': 'LCD display pin 2 show [TEXT] on line 1, [TEXT2] on line 2',
    },
    lcdchara: {
        'ja': 'LCDディスプレイ ピン2 [COL]行[ROW]列目に[TEXT]を表示',
        'ja-Hira': 'LCDディスプレイ ピン2 [COL]ぎょう[ROW]れつめに[TEXT]をひょうじ',
        'en': 'LCD display pin 2 show [TEXT] at line [COL] column [ROW]',
    },
    lcdclear: {
        'ja': 'LCDディスプレイ ピン2 表示を消す',
        'ja-Hira': 'LCDディスプレイ ピン2 ひょうじをけす',
        'en': 'clear LCD display pin 2',
    },
    ledbar: {
        'ja': 'LEDバー ピン[PIN]のレベルを[LEVEL]にする',
        'ja-Hira': 'LEDバー ピン[PIN]のレベルを[LEVEL]にする',
        'en': 'set LED bar pin [PIN] level to [LEVEL]',
    },
    ledbarbit: {
        'ja': 'LEDバー ピン[PIN]の表示を[BIT1][BIT2][BIT3][BIT4][BIT5][BIT6][BIT7][BIT8][BIT9][BIT10]',
        'ja-Hira': 'LEDバー ピン[PIN]のひょうじを[BIT1][BIT2][BIT3][BIT4][BIT5][BIT6][BIT7][BIT8][BIT9][BIT10]',
        'en': 'set LED bar pin [PIN] display to [BIT1][BIT2][BIT3][BIT4][BIT5][BIT6][BIT7][BIT8][BIT9][BIT10]',
    },
    buzzer: {
        'ja': 'ブザー ピン[PIN]を[OUTPUT]',
        'ja-Hira': 'ブザー ピン[PIN]を[OUTPUT]',
        'en': 'buzzer pin [PIN] to [OUTPUT]',
    },
    speaker: {
        'ja': 'スピーカ ピン[PIN]を[MSCALE]の音を[SEC]秒鳴らす',
        'ja-Hira': 'スピーカ ピン[PIN]を[MSCALE]のおとを[SEC]びょうならす',
        'en': 'speaker pin [PIN] play [MSCALE] for [SEC] sec',
    },
    recorderREC: {
        'ja': 'レコーダ ピン[PIN]の録音を[OUTPUT]',
        'ja-Hira': 'レコーダ ピン[PIN]のろくおんを[OUTPUT]',
        'en': 'recorder pin [PIN] record to [OUTPUT]',
    },
    recorderPlay: {
        'ja': 'レコーダ ピン[PIN]を再生',
        'ja-Hira': 'レコーダ ピン[PIN]をさいせい',
        'en': 'play recorder pin [PIN]',
    },
    playMp3: {
        'ja': '[TYPE] mp3プレイヤー ピン[PIN]の[NUM]番目の曲を再生',
        'ja-Hira': '[TYPE] mp3プレイヤー ピン[PIN]の[NUM]ばんめのきょくをさいせい',
        'en': '[TYPE] mp3 player pin [PIN] play song #[NUM]',
    },
    volumeMp3: {
        'ja': '[TYPE] mp3プレイヤー ピン[PIN]の音量を[NUM]にする',
        'ja-Hira': '[TYPE] mp3プレイヤー ピン[PIN]のおんりょうを[NUM]にする',
        'en': '[TYPE] mp3 player pin [PIN] set volume to [NUM]',
    },
    settingMp3: {
        'ja': '[TYPE] mp3プレイヤー ピン[PIN]の設定: [SETTING]',
        'ja-Hira': '[TYPE] mp3プレイヤー ピン[PIN]のせってい: [SETTING]',
        'en': '[TYPE] mp3 player pin [PIN] setting: [SETTING]',
    },
    settingGroveMp3: {
        'ja': 'Seeed studio mp3プレイヤー ピン[PIN]の再生モード: [SETTING]',
        'ja-Hira': 'Seeed studio mp3プレイヤー ピン[PIN]のさいせいモード: [SETTING]',
        'en': 'Seeed studio mp3 player pin [PIN] play mode: [SETTING]',
    },
    led_red: {
        'ja': 'あか',
        'ja-Hira': 'あか',
        'en': 'red',
    },
    led_blue: {
        'ja': 'あお',
        'ja-Hira': 'あお',
        'en': 'blue',
    },
    rtc_year: {
        'ja': '年',
        'ja-Hira': 'ねん',
        'en': 'year',
    },
    rtc_month: {
        'ja': '月',
        'ja-Hira': 'がつ',
        'en': 'month',
    },
    rtc_day: {
        'ja': '日',
        'ja-Hira': 'にち',
        'en': 'day',
    },
    rtc_hour: {
        'ja': '時',
        'ja-Hira': 'じ',
        'en': 'hour',
    },
    rtc_minute: {
        'ja': '分',
        'ja-Hira': 'ふん',
        'en': 'minute',
    },
    rtc_second: {
        'ja': '秒',
        'ja-Hira': 'びょう',
        'en': 'second',
    },
    rgb_off: {
        'ja': 'OFF',
        'ja-Hira': 'OFF',
        'en': 'OFF',
    },
    rgb_blue: {
        'ja': 'あお',
        'ja-Hira': 'あお',
        'en': 'blue',
    },
    rgb_green: {
        'ja': 'みどり',
        'ja-Hira': 'みどり',
        'en': 'green',
    },
    rgb_cyan: {
        'ja': 'シアン',
        'ja-Hira': 'シアン',
        'en': 'cyan',
    },
    rgb_red: {
        'ja': 'あか',
        'ja-Hira': 'あか',
        'en': 'red',
    },
    rgb_magenta: {
        'ja': 'マゼンタ',
        'ja-Hira': 'マゼンタ',
        'en': 'magenta',
    },
    rgb_yellow: {
        'ja': 'きいろ',
        'ja-Hira': 'きいろ',
        'en': 'yellow',
    },
    rgb_white: {
        'ja': 'しろ',
        'ja-Hira': 'しろ',
        'en': 'white',
    },
    music_low_la: {
        'ja': '低いラ',
        'ja-Hira': 'ひくいラ',
        'en': 'low A',
    },
    music_low_la_sharp: {
        'ja': '低いラ#',
        'ja-Hira': 'ひくいラ#',
        'en': 'low A#',
    },
    music_low_si: {
        'ja': '低いシ',
        'ja-Hira': 'ひくいシ',
        'en': 'low B',
    },
    music_do: {
        'ja': 'ド',
        'ja-Hira': 'ド',
        'en': 'C',
    },
    music_do_sharp: {
        'ja': 'ド#',
        'ja-Hira': 'ド#',
        'en': 'C#',
    },
    music_re: {
        'ja': 'レ',
        'ja-Hira': 'レ',
        'en': 'D',
    },
    music_re_sharp: {
        'ja': 'レ#',
        'ja-Hira': 'レ#',
        'en': 'D#',
    },
    music_mi: {
        'ja': 'ミ',
        'ja-Hira': 'ミ',
        'en': 'E',
    },
    music_fa: {
        'ja': 'ファ',
        'ja-Hira': 'ファ',
        'en': 'F',
    },
    music_fa_sharp: {
        'ja': 'ファ#',
        'ja-Hira': 'ファ#',
        'en': 'F#',
    },
    music_so: {
        'ja': 'ソ',
        'ja-Hira': 'ソ',
        'en': 'G',
    },
    music_la: {
        'ja': 'ラ',
        'ja-Hira': 'ラ',
        'en': 'A',
    },
    music_la_sharp: {
        'ja': 'ラ#',
        'ja-Hira': 'ラ#',
        'en': 'A#',
    },
    music_si: {
        'ja': 'シ',
        'ja-Hira': 'シ',
        'en': 'B',
    },
    music_high_do: {
        'ja': '高いド',
        'ja-Hira': 'たかいド',
        'en': 'high C',
    },
    music_high_do_sharp: {
        'ja': '高いド#',
        'ja-Hira': 'たかいド#',
        'en': 'high C#',
    },
    music_high_re: {
        'ja': '高いレ',
        'ja-Hira': 'たかいレ',
        'en': 'high D',
    },
    recorder_start: {
        'ja': 'スタート',
        'ja-Hira': 'スタート',
        'en': 'start',
    },
    recorder_stop: {
        'ja': 'ストップ',
        'ja-Hira': 'ストップ',
        'en': 'stop',
    },
    color_red: {
        'ja': 'あか',
        'ja-Hira': 'あか',
        'en': 'red',
    },
    color_green: {
        'ja': 'みどり',
        'ja-Hira': 'みどり',
        'en': 'green',
    },
    color_blue: {
        'ja': 'あお',
        'ja-Hira': 'あお',
        'en': 'blue',
    },
    color_clear: {
        'ja': '明度',
        'ja-Hira': 'めいど',
        'en': 'brightness',
    },
    temp: {
        'ja': 'おんど',
        'ja-Hira': 'おんど',
        'en': 'temperature',
    },
    humid: {
        'ja': 'しつど',
        'ja-Hira': 'しつど',
        'en': 'humidity',
    },
    sound_direction: {
        'ja': 'かくど',
        'ja-Hira': 'かくど',
        'en': 'angle',
    },
    sound_activity: {
        'ja': '大きさ',
        'ja-Hira': 'おおきさ',
        'en': 'magnitude',
    },
    mp3_volume_up: {
        'ja': '音量を大きくする',
        'ja-Hira': 'おんりょうをおおきくする',
        'en': 'volume up',
    },
    mp3_volume_down: {
        'ja': '音量を小さくする',
        'ja-Hira': 'おんりょうをちいさくする',
        'en': 'volume down',
    },
    mp3_next_song: {
        'ja': '次の曲を再生する',
        'ja-Hira': 'つぎのきょくをさいせいする',
        'en': 'next song',
    },
    mp3_previous_song: {
        'ja': '前の曲を再生する',
        'ja-Hira': 'まえのきょくをさいせいする',
        'en': 'previous song',
    },
    mp3_pause_play: {
        'ja': '一時停止・再開',
        'ja-Hira': 'いちじていし・さいかい',
        'en': 'pause / play',
    },
    mp3_no_loop: {
        'ja': 'リピートなし',
        'ja-Hira': 'リピートなし',
        'en': 'no repeat',
    },
    mp3_single_loop: {
        'ja': '1曲リピート',
        'ja-Hira': '1きょくリピート',
        'en': 'repeat single',
    },
    mp3_all_loop: {
        'ja': 'リピート',
        'ja-Hira': 'リピート',
        'en': 'repeat all',
    },
    mp3_random: {
        'ja': 'ランダム',
        'ja-Hira': 'ランダム',
        'en': 'random',
    },
    noList: {
        'ja': '(リストなし)',
        'ja-Hira': '(リストなし)',
        'en': '(no list)',
    },
}

const LED_PINS = {
    ONE: 'board.LED_RED',
    TWO: 'board.LED_BLUE',
}
const INOUT_PINS = {
    ONE: 'Port1',
    TWO: 'Port2',
}

const INPUT_PINS = {
    ONE: 'Port1',
    TWO: 'Port2',
    THREE: 'Port3',
}

// 7セグの選択式文字入力用
const SEVEN_SEGMENT_TEXT = {
    LOVE: 'L0VE',
    GO: 'G0',
    ON: '0N',
    OFF: '0FF',
    OK: '0K',
    NG: 'nG',
};
const LED_LEVEL = {
    ZERO: '0',
    ONE: '1',
    TWO: '2',
    THREE: '3',
    FOUR: '4',
    FIVE: '5',
    SIX: '6',
    SEVEN: '7',
    EIGHT: '8',
    NINE: '9',
    TEN:'10',
}

const RGB_LED = {
    OFF: 'off',
    BLUE: 'blue',
    GREEN: 'green',
    CYAN: 'cyan',
    RED: 'red',
    MAGENTA: 'magenta',
    YELLOW: 'yellow',
    WHITE: 'white',
}

const OUTPUT_BOOLEAN = {
    ON: '1',
    OFF: '0',
}

const MUSIC_SCALE = {
    A3: '220.0',
    AS3: '233.082',
    B3: '246.942',
    C4: '261.626',
    CS4: '277.183',
    D4: '293.665',
    DS4: '311.127',
    E4: '329.628',
    F4: '349.228',
    FS4: '369.994',
    G4: '391.995',
    GS4: '415.305',
    A4: '440.0',
    AS4: '466.164',
    B4: '493.883',
    C5: '523.251',
    CS5: '554.365',
    D5: '587.330'
};

const COLOR = {
    R: 'red',
    G: 'green',
    B: 'blue',
    C: 'clear'
};

const TEMP_HUMID = {
    TEMP: 'temperature',
    HUMID: 'humidity',
};

const SOUND_DIRECTION = {
    DIRECTION: 'direction',
    ACTIVITY: 'activity',
};

const MP3PLAYER = {
    VOLUME_UP: '+',
    VOLUME_DOWN: '-',
    NEXT_SONG: 'n',
    PAUSE_PLAY: 'p',
    PREVIOUS_SONG: 'b',
};

const SEEED_MP3PLAYER = {
    PLAYMODE_SINGLE_NO_LOOP: 'w',
    PLAYMODE_SINGLE_LOOP: 'x',
    PLAYMODE_ALL_LOOP: 'y',
    PLAYMODE_RANDOM: 'z',
}
const SPEECH_RECOGNIZER = {
    TURN_ON_THE_LIGHT: '1',
    TURN_OFF_THE_LIGHT: '2',
    PLAY_MUSIC: '3',
    PAUSE: '4',
    NEXT: '5',
    PREVIOUS: '6',
    UP: '7',
    DOWN: '8',
    TURN_ON_THE_TV: '9',
    TURN_OFF_THE_TV: '10',
    INCREASE_TEMPERATURE: '11',
    DECREASE_TEMPERATURE: '12',
    WHATS_THE_TIME: '13',
    OPEN_THE_DOOR: '14',
    CLOSE_THE_DOOR: '15',
    LEFT: '16',
    RIGHT: '17',
    STOP: '18',
    START: '19',
    MODE_1: '20',
    MODE_2: '21',
    GO: '22'
};
const NEOPIXEL_TYPE = {
    SEEED: 'SEEED',
    M5: 'M5'
}
const MP3PLAYER_TYPE = {
    SEEED: 'SEEED',
    DFPLAYER: 'DFPlayer',
}
const RTC_DATE = {
    YEAR: 'year',
    MONTH: 'month',
    DAY: 'dayOfMonth',
    HOUR: 'hour',
    MINUTE: 'minute',
    SECOND: 'second'
}

class MakerBoardAdvance {
    constructor (runtime) {
        this.runtime = runtime;
        this.writeFile = false;
        this.isLoop = false;
        this.sources = '';
        this.isRecieveMessage = false;
        this.stopFlag = false;
        this.readFlag = false;
        this.message1 = '';
        this.message2 = '';
        this.message3 = '';
        this.writeMessage = '';
        this.port;
    }

    getInfo () {
        let today = new Date()
        return {
            id: 'makerBoardAdvance',
            name: Message.categoryName[this.setLocale()],
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            color1: '#DDAF38', // ブロックのメイン色
            color2: '#C49B32', // ブロックの影の色
            blocks: [
                {
                    opcode: 'help',
                    blockType: BlockType.COMMAND,
                    text: Message.help[this.setLocale()],
                },
                '---',
                {
                    opcode:'nowtime',
                    blockType: BlockType.REPORTER,
                    text: Message.nowtime[this.setLocale()]
                },
                {
                    opcode: 'timerLoop',
                    blockType: BlockType.LOOP,
                    text: 'タイマー割り込み：[INTERVAL]ミリ秒ごとに繰り返す',
                    arguments: {
                        INTERVAL: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1000
                        }
                    }
                },
                '---',
                {
                    opcode:'pi',
                    blockType: BlockType.REPORTER,
                    text: Message.pi[this.setLocale()]
                },
                '---',
                {
                    opcode: 'log',
                    blockType: BlockType.COMMAND,
                    text: Message.log[this.setLocale()],
                    arguments: {
                        ID: {
                            type: ArgumentType.NUMBER,
                            menu: 'id',
                            defaultValue: '1'
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Hello World'
                        }
                    }
                },
                {
                    opcode: 'serialAvailable',
                    blockType: BlockType.CONDITIONAL,
                    text: Message.serialAvailable[this.setLocale()],
                },
                {
                    opcode: 'revMessage',
                    blockType: BlockType.REPORTER,
                    text: Message.revMessage[this.setLocale()]
                },
                {
                    opcode: 'toNumber',
                    blockType: BlockType.REPORTER,
                    text: Message.toNumber[this.setLocale()],
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'updateList',
                    blockType: BlockType.COMMAND,
                    text: Message.updateList[this.setLocale()],
                    arguments: {
                        LIST: {
                            type: ArgumentType.STRING,
                            menu: 'scratchLists'
                        }
                    }
                },
                '---',
                {
                    opcode: 'servowithtime',
                    blockType: BlockType.COMMAND,
                    text: Message.servowithtime[this.setLocale()],
                    arguments: {
                        SERVO: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '1'
                        },
                        SECOND: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        },
                        ANGLE1: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE2: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        }
                    }
                },
                {
                    opcode: 'servowithtime_two',
                    blockType: BlockType.COMMAND,
                    text: Message.servowithtime_two[this.setLocale()],
                    arguments: {
                        SERVO1: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '1'
                        },
                        SERVO2: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '2'
                        },
                        SECOND: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        },
                        ANGLE1: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE2: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE3: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE4: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        }
                    }
                },
                {
                    opcode: 'servowithtime_three',
                    blockType: BlockType.COMMAND,
                    text: Message.servowithtime_three[this.setLocale()],
                    arguments: {
                        SERVO1: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '1'
                        },
                        SERVO2: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '2'
                        },
                        SERVO3: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: '3'
                        },
                        SECOND: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        },
                        ANGLE1: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE2: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE3: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE4: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE5: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE6: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        }

                    }
                },
                {
                    opcode: 'servowithtime_four',
                    blockType: BlockType.COMMAND,
                    text: Message.servowithtime_four[this.setLocale()],
                    arguments: {
                        SECOND: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        },
                        ANGLE1: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE2: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE3: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE4: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE5: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE6: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        },
                        ANGLE7: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        ANGLE8: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '60'
                        }
                    }
                },
                '---',
                {
                    opcode: 'setRTC_DS1307',
                    blockType: BlockType.COMMAND,
                    text: Message.setRTC_DS1307[this.setLocale()],
                    arguments: {
                        YY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getFullYear()
                        },
                        MM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getMonth()+1
                        },
                        DD: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getDate()
                        },
                        H: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getHours()
                        },
                        M: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getMinutes()
                        },
                        S: {
                            type: ArgumentType.NUMBER,
                            defaultValue: today.getSeconds()
                        }
                    },
                },
                {
                    opcode: 'getRTC_DS1307',
                    blockType: BlockType.COMMAND,
                    text: Message.getRTC_DS1307[this.setLocale()],
                },
                {
                    opcode: 'valRTC_DS1307',
                    blockType: BlockType.REPORTER,
                    text: Message.valRTC_DS1307[this.setLocale()],
                    arguments: {
                        VALUE: {
                            type: ArgumentType.STRING,
                            menu: 'rtc_date',
                            defaultValue: RTC_DATE.MINUTE,
                        },
                    },
                },
                '---',
                {
                    opcode: 'rgbledselect',
                    blockType: BlockType.COMMAND,
                    text: Message.rgbledselect[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        OUTPUT: {
                            type: ArgumentType.STRING,
                            menu: 'rgb_led',
                            defaultValue: RGB_LED.RED
                        }
                    },
                },
                {
                    opcode: 'rgbled',
                    blockType: BlockType.COMMAND,
                    text: Message.rgbled[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        RED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        GREEN: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        BLUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                    },
                },
                {
                    opcode: 'neopixelselect',
                    blockType: BlockType.COMMAND,
                    text: Message.neopixelselect[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'neopixel_types',
                            defaultValue: NEOPIXEL_TYPE.SEEED
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        OUTPUT: {
                            type: ArgumentType.STRING,
                            menu: 'rgb_led',
                            defaultValue: RGB_LED.RED
                        }
                    },
                },
                {
                    opcode: 'neopixel',
                    blockType: BlockType.COMMAND,
                    text: Message.neopixel[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'neopixel_types',
                            defaultValue: NEOPIXEL_TYPE.SEEED
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        RED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        GREEN: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        BLUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                    },
                },
                {
                    opcode: 'neopixelclear',
                    blockType: BlockType.COMMAND,
                    text: Message.neopixelclear[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'neopixel_types',
                            defaultValue: NEOPIXEL_TYPE.SEEED
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                    },
                },
                {
                    opcode: 'sevensegnum',
                    blockType: BlockType.COMMAND,
                    text: Message.sevensegnum[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        }
                    },
                },
                {
                    opcode: 'sevensegstr',
                    blockType: BlockType.COMMAND,
                    text: Message.sevensegstr[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: SEVEN_SEGMENT_TEXT.LOVE
                        }
                    },
                },
                {
                    opcode: 'sevensegstrselect',
                    blockType: BlockType.COMMAND,
                    text: Message.sevensegstr[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            menu: 'seven_segment_text',
                            defaultValue: SEVEN_SEGMENT_TEXT.LOVE
                        }
                    },
                },
                {
                    opcode: 'sevensegclear',
                    blockType: BlockType.COMMAND,
                    text: Message.sevensegclear[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                    },
                },
                {
                    opcode: 'lcdtext',
                    blockType: BlockType.COMMAND,
                    text: Message.lcdtext[this.setLocale()],
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello"
                        },
                        TEXT2: {
                            type: ArgumentType.STRING,
                            defaultValue: "World!"
                        }
                    }
                },
                {
                    opcode: 'lcdchara',
                    blockType: BlockType.COMMAND,
                    text: Message.lcdchara[this.setLocale()],
                    arguments: {
                        COL: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        ROW: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "I"
                        }
                    }
                },
                {
                    opcode: 'lcdclear',
                    blockType: BlockType.COMMAND,
                    text: Message.lcdclear[this.setLocale()],
                },
                {
                opcode: 'ledbar',
                blockType: BlockType.COMMAND,
                text: Message.ledbar[this.setLocale()],
                arguments: {
                    PIN: {
                        type: ArgumentType.STRING,
                        menu: 'inout_pins',
                        defaultValue: INPUT_PINS.ONE
                    },
                    LEVEL: {
                        type: ArgumentType.STRING,
                        menu: 'led_level',
                        defaultValue: LED_LEVEL.ZERO
                    }                    },
                },
                {
                    opcode: 'ledbarbit',
                    blockType: BlockType.COMMAND,
                    text: Message.ledbarbit[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INPUT_PINS.ONE
                        },
                        BIT1: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT2: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT3: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT4: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT5: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT6: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT7: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT8: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT9: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        },
                        BIT10: {
                            type: ArgumentType.STRING,
                            menu: 'led_bar_boolean',
                            defaultValue: OUTPUT_BOOLEAN.OFF
                        }
                    },
                },
                '---',
                {
                    opcode: 'buzzer',
                    blockType: BlockType.COMMAND,
                    text: Message.buzzer[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        OUTPUT: {
                            type: ArgumentType.STRING,
                            menu: 'output',
                            defaultValue: 'HIGH'
                        }                    },
                },
                {
                    opcode: 'speaker', //きれいな音が出ないので要修正
                    blockType: BlockType.COMMAND,
                    text: Message.speaker[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins', //サーボピンにつなぐ
                            defaultValue: INOUT_PINS.ONE
                        },
                        MSCALE: {
                            type: ArgumentType.STRING,
                            menu: 'music_scale',
                            defaultValue: MUSIC_SCALE.C4
                        },
                        SEC: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                    },
                },
                {
                    opcode: 'recorderREC',
                    blockType: BlockType.COMMAND,
                    text: Message.recorderREC[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        OUTPUT: {
                            type: ArgumentType.STRING,
                            menu: 'recorder',
                            defaultValue: 'LOW'
                        },
                    },
                },
                {
                    opcode: 'recorderPlay',
                    blockType: BlockType.COMMAND,
                    text: Message.recorderPlay[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                    },
                },
                '---',
                // {
                //     opcode: 'sendIR',
                //     blockType: BlockType.COMMAND,
                //     text: '赤外線送信 ピン[PIN]がコマンド[NUM]をおくる',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'inout_pins',
                //             defaultValue: INOUT_PINS.ONE
                //         },
                //         NUM: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 1
                //         }                    },
                // },
                // {
                //     opcode: 'checkReceivedIR',
                //     blockType: BlockType.BOOLEAN,
                //     text: '赤外線受信 ピン[PIN]が受信した',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'input_pins',
                //             defaultValue: INPUT_PINS.ONE
                //         },              },
                // },
                // {
                //     opcode: 'readIR',
                //     blockType: BlockType.REPORTER,
                //     text: '赤外線受信 ピン[PIN]のあたい',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.NUMBER,
                //             menu: 'input_pins',
                //             defaultValue: INPUT_PINS.ONE
                //         },              },
                // },
                // {
                //     opcode: 'resetReadIR',
                //     blockType: BlockType.COMMAND,
                //     text: '赤外線受信 ピン[PIN]をリセット',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.NUMBER,
                //             menu: 'input_pins',
                //             defaultValue: INPUT_PINS.ONE
                //         },              },
                // },
                // {
                //     opcode: 'checkSpeechRecognizer',
                //     blockType: BlockType.BOOLEAN,
                //     text: '音声認識 ピン[PIN]が受信した',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'inout_pins',
                //             defaultValue: INOUT_PINS.ONE
                //         },              },
                // },
                // {
                //     opcode: 'readSpeechRecognizer',
                //     blockType: BlockType.REPORTER,
                //     text: '音声認識 ピン[PIN]のあたい',
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'inout_pins',
                //             defaultValue: INOUT_PINS.ONE
                //         },              },
                // },
                // '---',
                {
                    opcode: 'playMp3',
                    blockType: BlockType.COMMAND,
                    text: Message.playMp3[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'mp3player_types',
                            defaultValue: MP3PLAYER_TYPE.DFPLAYER
                        },
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }              },
                },
                {
                    opcode: 'volumeMp3',
                    blockType: BlockType.COMMAND,
                    text: Message.volumeMp3[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'mp3player_types',
                            defaultValue: MP3PLAYER_TYPE.DFPLAYER
                        },
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        NUM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }              },
                },
                {
                    opcode: 'settingMp3',
                    blockType: BlockType.COMMAND,
                    text: Message.settingMp3[this.setLocale()],
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'mp3player_types',
                            defaultValue: MP3PLAYER_TYPE.DFPLAYER
                        },
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        SETTING: {
                            type: ArgumentType.STRING,
                            menu: 'mp3player',
                            defaultValue: MP3PLAYER.VOLUME_UP
                        },
                    },
                },
                                {
                    opcode: 'settingGroveMp3',
                    blockType: BlockType.COMMAND,
                    text: Message.settingGroveMp3[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout_pins',
                            defaultValue: INOUT_PINS.ONE
                        },
                        SETTING: {
                            type: ArgumentType.STRING,
                            menu: 'grove_mp3player_mode',
                            defaultValue: SEEED_MP3PLAYER.PLAYMODE_SINGLE_NO_LOOP
                        },
                    },
                },

            ],

            menus: {
                led_pins: {
                    acceptReporters: true,
                    items: this.LED_PIN_MENU
                },
                inout_pins: {
                    acceptReporters: true,
                    items: this.INOUT_PIN_MENU
                },
                input_pins: {
                    acceptReporters: true,
                    items: this.INPUT_PIN_MENU
                },
                rtc_date: {
                    acceptReporters: true,
                    items: this.RTC_DATE_MENU
                },
                seven_segment_text: {
                    acceptReporters: true,
                    items: this.SEVEN_SEGMENT_TEXT_MENU
                },
                led_level: {
                    acceptReporters: true,
                    items: this.LED_LEVEL_MENU
                },
                led_bar_boolean: {
                    acceptReporters: true,
                    items: this.LED_BAR_BOOLEAN_MENU
                },
                rgb_led: {
                    acceptReporters: true,
                    items: this.RGB_LED_MENU
                },
                neopixel_types: {
                    acceptReporters: true,
                    items: this.NEOPIXEL_TYPE_MENU
                },
                mp3player_types: {
                    acceptReporters: true,
                    items: this.MP3PLAYER_TYPE_MENU
                },
                music_scale: {
                    acceptReporters: true,
                    items: this.MUSIC_SCALE_MENU
                },
                recorder: {
                    acceptReporters: true,
                    items: this.RECORDER_MENU
                },
                servo: {
                    acceptReporters: true,
                    items: this.SERVO_MENU
                },
                motor: {
                    acceptReporters: true,
                    items: this.MOTOR_MENU
                },
                output: {
                    acceptReporters: true,
                    items: this.OUTPUT_MENU
                },
                id: {
                    acceptReporters: true,
                    items: this.ID_MENU
                },
                color: {
                    acceptReporters: true,
                    items: this.COLOR_MENU
                },
                temp_humid: {
                    acceptReporters: true,
                    items: this.TEMP_HUMID_MENU
                },
                sound_direction: {
                    acceptReporters: true,
                    items: this.SOUND_DIRECTION_MENU
                },
                mp3player: {
                    acceptReporters: true,
                    items: this.MP3PLAYER_MENU
                },
                grove_mp3player_mode: {
                    acceptReporters: true,
                    items: this.SEEED_MP3PLAYER_MENU
                },
                speechRecognizer: {
                    acceptReporters: true,
                    items: this.SPEECH_RECOGNIZER_MENU
                },
                scratchLists: {
                    acceptReporters: false,
                    items: 'getScratchListMenu'
                },
            }
        };
    }
    get ID_MENU(){
        return [
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            },
        ]
    }

    get SERVO_MENU(){
        return[
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            },
            {
                text: '4',
                value: '4'
            },
        ]
    }

    get MOTOR_MENU(){
        return[
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            },
            {
                text: '4',
                value: '4'
            },
        ]
    }
    get LED_PIN_MENU(){
        return[
            {
                text: Message.led_red[this.setLocale()],
                value: LED_PINS.ONE
            },
            {
                text: Message.led_blue[this.setLocale()],
                value: LED_PINS.TWO
            }
        ]
    }
    get OUTPUT_MENU(){
        return[
            {
                text: 'ON',
                value: 'HIGH'
            },
            {
                text: 'OFF',
                value: 'LOW'
            }
        ]
    }
    get RTC_DATE_MENU(){
        return[
            {
                text: Message.rtc_year[this.setLocale()],
                value: RTC_DATE.YEAR
            },
            {
                text: Message.rtc_month[this.setLocale()],
                value: RTC_DATE.MONTH
            },
            {
                text: Message.rtc_day[this.setLocale()],
                value: RTC_DATE.DAY
            },
            {
                text: Message.rtc_hour[this.setLocale()],
                value: RTC_DATE.HOUR
            },
            {
                text: Message.rtc_minute[this.setLocale()],
                value: RTC_DATE.MINUTE
            },
            {
                text: Message.rtc_second[this.setLocale()],
                value: RTC_DATE.SECOND
            },
        ]
    }
    get LED_BAR_BOOLEAN_MENU(){
        return[
            {
                text: 'O',
                value: OUTPUT_BOOLEAN.ON
            },
            {
                text: 'X',
                value: OUTPUT_BOOLEAN.OFF
            }
        ]
    }
    get RGB_LED_MENU(){
        return[
            {
                text: Message.rgb_off[this.setLocale()],
                value: RGB_LED.OFF
            },
            {
                text: Message.rgb_blue[this.setLocale()],
                value: RGB_LED.BLUE
            },
            {
                text: Message.rgb_green[this.setLocale()],
                value: RGB_LED.GREEN
            },
            {
                text: Message.rgb_cyan[this.setLocale()],
                value: RGB_LED.CYAN
            },
            {
                text: Message.rgb_red[this.setLocale()],
                value: RGB_LED.RED
            },
            {
                text: Message.rgb_magenta[this.setLocale()],
                value: RGB_LED.MAGENTA
            },
            {
                text: Message.rgb_yellow[this.setLocale()],
                value: RGB_LED.YELLOW
            },
            {
                text: Message.rgb_white[this.setLocale()],
                value: RGB_LED.WHITE
            },
        ]
    }
    get NEOPIXEL_TYPE_MENU(){
        return [
            {
                text: 'Seeed studio',
                value: NEOPIXEL_TYPE.SEEED
            },
            {
                text: 'M5Stack',
                value: NEOPIXEL_TYPE.M5
            }
        ]
    }
    get MP3PLAYER_TYPE_MENU(){
        return [
            {
                text: 'DFPlayer Mini',
                value: MP3PLAYER_TYPE.DFPLAYER
            },
            {
                text: 'Seeed studio',
                value: MP3PLAYER_TYPE.SEEED
            },
        ]
    }
    get INOUT_PIN_MENU(){
        return [
            {
                text: '1',
                value: INOUT_PINS.ONE
            },
            {
                text: '2',
                value: INOUT_PINS.TWO
            },
        ]
    }
    get INPUT_PIN_MENU(){
        return [
            {
                text: '1',
                value: INPUT_PINS.ONE
            },
            {
                text: '2',
                value: INPUT_PINS.TWO
            },
            {
                text: '3',
                value: INPUT_PINS.THREE
            },
        ]
    }
    get SEVEN_SEGMENT_TEXT_MENU(){
        return [
            { text: 'LOVE', value: SEVEN_SEGMENT_TEXT.LOVE },
            { text: 'GO', value: SEVEN_SEGMENT_TEXT.GO },
            { text: 'ON', value: SEVEN_SEGMENT_TEXT.ON },
            { text: 'OFF', value: SEVEN_SEGMENT_TEXT.OFF },
            { text: 'OK', value: SEVEN_SEGMENT_TEXT.OK },
            { text: 'NG', value: SEVEN_SEGMENT_TEXT.NG },
        ]
    }
    get LED_LEVEL_MENU(){
        return [
            {
                text: '0',
                value: LED_LEVEL.ZERO
            },
            {
                text: '1',
                value: LED_LEVEL.ONE
            },
            {
                text: '2',
                value: LED_LEVEL.TWO
            },
            {
                text: '3',
                value: LED_LEVEL.THREE
            },
            {
                text: '4',
                value: LED_LEVEL.FOUR
            },
            {
                text: '5',
                value: LED_LEVEL.FIVE
            },
            {
                text: '6',
                value: LED_LEVEL.SIX
            },
            {
                text: '7',
                value: LED_LEVEL.SEVEN
            },
            {
                text: '8',
                value: LED_LEVEL.EIGHT
            },
            {
                text: '9',
                value: LED_LEVEL.NINE
            },
            {
                text: '10',
                value: LED_LEVEL.TEN
            },
        ]
    }
    get MUSIC_SCALE_MENU(){
        return [
            { text: Message.music_low_la[this.setLocale()], value: MUSIC_SCALE.A3 },
            { text: Message.music_low_la_sharp[this.setLocale()], value: MUSIC_SCALE.AS3 },
            { text: Message.music_low_si[this.setLocale()], value: MUSIC_SCALE.B3 },
            { text: Message.music_do[this.setLocale()], value: MUSIC_SCALE.C4 },
            { text: Message.music_do_sharp[this.setLocale()], value: MUSIC_SCALE.CS4 },
            { text: Message.music_re[this.setLocale()], value: MUSIC_SCALE.D4 },
            { text: Message.music_re_sharp[this.setLocale()], value: MUSIC_SCALE.DS4 },
            { text: Message.music_mi[this.setLocale()], value: MUSIC_SCALE.E4 },
            { text: Message.music_fa[this.setLocale()], value: MUSIC_SCALE.F4 },
            { text: Message.music_fa_sharp[this.setLocale()], value: MUSIC_SCALE.FS4 },
            { text: Message.music_so[this.setLocale()], value: MUSIC_SCALE.G4 },
            { text: Message.music_la[this.setLocale()], value: MUSIC_SCALE.A4 },
            { text: Message.music_la_sharp[this.setLocale()], value: MUSIC_SCALE.AS4 },
            { text: Message.music_si[this.setLocale()], value: MUSIC_SCALE.B4 },
            { text: Message.music_high_do[this.setLocale()], value: MUSIC_SCALE.C5 },
            { text: Message.music_high_do_sharp[this.setLocale()], value: MUSIC_SCALE.CS5 },
            { text: Message.music_high_re[this.setLocale()], value: MUSIC_SCALE.D5 }

        ]
    }
    get RECORDER_MENU(){
        return [
            { text: Message.recorder_start[this.setLocale()], value: 'LOW'},
            { text: Message.recorder_stop[this.setLocale()], value: 'HIGH'},

        ]
    }

    get COLOR_MENU (){
        return [
            {
                text: Message.color_red[this.setLocale()],
                value: COLOR.R
            },
            {
                text: Message.color_green[this.setLocale()],
                value: COLOR.G
            },
            {
                text: Message.color_blue[this.setLocale()],
                value: COLOR.B
            },
            {
                text: Message.color_clear[this.setLocale()],
                value: COLOR.C
            }
        ];
    }
    get TEMP_HUMID_MENU (){
        return [
            {
                text: Message.temp[this.setLocale()],
                value: TEMP_HUMID.TEMP
            },
            {
                text: Message.humid[this.setLocale()],
                value: TEMP_HUMID.HUMID
            },
        ];
    }
    get SOUND_DIRECTION_MENU (){
        return [
            {
                text: Message.sound_direction[this.setLocale()],
                value: SOUND_DIRECTION.DIRECTION
            },
            {
                text: Message.sound_activity[this.setLocale()],
                value: SOUND_DIRECTION.ACTIVITY
            },
        ];
    }
    get MP3PLAYER_MENU (){
        return [
            {
                text: Message.mp3_volume_up[this.setLocale()],
                value: MP3PLAYER.VOLUME_UP
            },
            {
                text: Message.mp3_volume_down[this.setLocale()],
                value: MP3PLAYER.VOLUME_DOWN
            },
            {
                text: Message.mp3_next_song[this.setLocale()],
                value: MP3PLAYER.NEXT_SONG
            },
            {
                text: Message.mp3_previous_song[this.setLocale()],
                value: MP3PLAYER.PREVIOUS_SONG
            },
            {
                text: Message.mp3_pause_play[this.setLocale()],
                value: MP3PLAYER.PAUSE_PLAY
            },
        ];
    }
    get SEEED_MP3PLAYER_MENU (){
        return [
            {
                text: Message.mp3_no_loop[this.setLocale()],
                value: SEEED_MP3PLAYER.PLAYMODE_SINGLE_NO_LOOP
            },
            {
                text: Message.mp3_single_loop[this.setLocale()],
                value: SEEED_MP3PLAYER.PLAYMODE_SINGLE_LOOP
            },
            {
                text: Message.mp3_all_loop[this.setLocale()],
                value: SEEED_MP3PLAYER.PLAYMODE_ALL_LOOP
            },
            {
                text: Message.mp3_random[this.setLocale()],
                value: SEEED_MP3PLAYER.PLAYMODE_RANDOM
            },
        ];
    }
    get SPEECH_RECOGNIZER_MENU (){
        return [
            {
                text: 'Turn on the light',
                value: SPEECH_RECOGNIZER.TURN_ON_THE_LIGHT
            },
            {
                text: 'Turn off the light',
                value: SPEECH_RECOGNIZER.TURN_OFF_THE_LIGHT
            },
            {
                text: 'Play music',
                value: SPEECH_RECOGNIZER.PLAY_MUSIC
            },
            {
                text: 'Pause',
                value: SPEECH_RECOGNIZER.PAUSE
            },
            {
                text: 'Next',
                value: SPEECH_RECOGNIZER.NEXT
            },
            {
                text: 'Previous',
                value: SPEECH_RECOGNIZER.PREVIOUS
            },
            {
                text: 'Up',
                value: SPEECH_RECOGNIZER.UP
            },
            {
                text: 'Down',
                value: SPEECH_RECOGNIZER.DOWN
            },
            {
                text: 'Turn on the TV',
                value: SPEECH_RECOGNIZER.TURN_ON_THE_TV
            },
            {
                text: 'Turn off the TV',
                value: SPEECH_RECOGNIZER.TURN_OFF_THE_TV
            },
            {
                text: 'Increase temperature',
                value: SPEECH_RECOGNIZER.INCREASE_TEMPERATURE
            },
            {
                text: 'Decrease temperature',
                value: SPEECH_RECOGNIZER.DECREASE_TEMPERATURE
            },
            {
                text: 'What’s the time',
                value: SPEECH_RECOGNIZER.WHATS_THE_TIME
            },
            {
                text: 'Open the door',
                value: SPEECH_RECOGNIZER.OPEN_THE_DOOR
            },
            {
                text: 'Close the door',
                value: SPEECH_RECOGNIZER.CLOSE_THE_DOOR
            },
            {
                text: 'Left',
                value: SPEECH_RECOGNIZER.LEFT
            },
            {
                text: 'Right',
                value: SPEECH_RECOGNIZER.RIGHT
            },
            {
                text: 'Stop',
                value: SPEECH_RECOGNIZER.STOP
            },
            {
                text: 'Start',
                value: SPEECH_RECOGNIZER.START
            },
            {
                text: 'Mode 1',
                value: SPEECH_RECOGNIZER.MODE_1
            },
            {
                text: 'Mode 2',
                value: SPEECH_RECOGNIZER.MODE_2
            },
            {
                text: 'Go',
                value: SPEECH_RECOGNIZER.GO
            }
        ];
    }
    help(){
        const helpURL = 'https://makerboard.ux-xu.com/?v=18475fc53f3b814dbbaf000caa140174&p=18475fc53f3b81ed8714cd7faebdcc40&pm=s';
        window.open(helpURL);
    }
    nowtime(){}
    timerLoop(){}
    pi(){}

    getScratchListMenu () {
        const lists = [];
        const stage = this.runtime.getTargetForStage();
        if (stage) {
            Object.values(stage.variables)
                .filter(v => v.type === 'list')
                .forEach(v => lists.push(v.name));
        }
        const target = this.runtime.getEditingTarget();
        if (target && !target.isStage) {
            Object.values(target.variables)
                .filter(v => v.type === 'list')
                .forEach(v => lists.push(v.name));
        }
        if (lists.length === 0) return [{text: Message.noList[this.setLocale()], value: ''}];
        return lists.map(name => ({text: name, value: name}));
    }

    serialAvailable(){}
    readSerial(){}
    revMessage(){}
    toNumber(){}
    updateList(){}
    log(){}

    servowithtime(){}
    testblock(){}
    servowithtime_two(){}
    servowithtime_three(){}
    servowithtime_four(){}

    setRTC_DS1307(){}
    getRTC_DS1307(){}
    valRTC_DS1307(){}
    rgbled(){}
    rgbledselect(){}
    neopixelselect(){}
    neopixel(){}
    neopixelclear(){}
    sevensegnum(){}
    sevensegstr(){}
    sevensegstrselect(){}
    sevensegclear(){}
    lcdtext(){}
    lcdchara(){}
    lcdclear(){}
    ledbar(){}
    ledbarbit(){}
    buzzer(){}
    speaker(){}
    recorderREC(){}
    recorderPlay(){}
    sendIR(){}
    checkReceivedIR(){}
    readIR(){}
    resetReadIR(){}
    playMp3(){}
    volumeMp3(){}
    settingMp3(){}
    settingGroveMp3(){}
    checkSpeechRecognizer(){}
    readSpeechRecognizer(){}

    setLocale() {
        const locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        }
        return 'en';
    }
}

module.exports = MakerBoardAdvance;
